import components from '../components';
import HistoriqueController from './historique.controller';
import HistoriqueTemplate from './historique.template.html';

components
  .component('historique', {
    bindings: {},
    controller: HistoriqueController,
    template: HistoriqueTemplate
  });



// WEBPACK FOOTER //
// ./src/app/components/historique/historique.component.js